<template>
    <div class="search-bar">
        <div class="d-flex align-items-center">
            <label class="mr-sm-2 mb-0">Pencarian</label>
            <form class="form-inline d-flex flex-wrap">
                <div class="form-group mb-0">
                    <input type="text" style="min-width: 200px;" v-model="searchText" class="form-control" @keyup.enter="doSearch"
                        placeholder="keterangan..." data-lpignore="true">
                </div>
                <div class="form-group mb-0">
                    <date-picker v-model="searchDate" range type="date" placeholder="Tanggal" :editable="false" format="DD-MM-YYYY"></date-picker>
                </div>
                <div class="input-group">
                    <multiselect class="w-auto flex-grow-1" v-model="searchGudang" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="form-group mb-0">
                    <multiselect v-model="searchJenis" :options="jenisOptions" :placeholder="'Pilih jenis'" :searchable="true"
                        label="name" track-by="value" :show-labels="false"></multiselect>
                </div>
                <div class="form-group mb-0 mr-1">
                    <multiselect v-model="searchStatus" :options="statusOptions" :placeholder="'Pilih status'" :searchable="true"
                        label="name" track-by="value" :show-labels="false"></multiselect>
                </div>
                <div class="form-group mb-0">
                    <button class="btn btn-primary" @click.prevent="doSearch">Cari</button>
                    <button class="btn btn-light" @click.prevent="resetSearch">Reset</button>
                </div>
            </form>
        </div>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import GudangSelector from '../gudangs/Selector';

export default {
    components: {
        Multiselect,
        DatePicker,
        GudangSelector,
    },

    data() {
        return {
            selectGudang: false,
            gudangOptions: [],
            searchGudang: null,
            searchText: '',
            searchDate: '',
            searchStatus: null,
            searchJenis: null,
            statusOptions: [
                {
                    value: 1,
                    name: 'Debet'
                },
                {
                    value: 2,
                    name: 'Kredit'
                },
            ],
            jenisOptions: [
                {
                    value: 'PindahGudang',
                    name: 'Pembayaran DP Pindah Gudang',
                },
                {
                    value: 'PindahGudangPelunasan',
                    name: 'Pelunasan DP Pindah Gudang',
                },
                {
                    value: 'StrippingPenerimaan',
                    name: 'Stripping',
                },
                {
                    value: 'ReDryPenerimaan',
                    name: 'Re Dry',
                },
                {
                    value: 'BlendingPenerimaan',
                    name: 'Blending',
                },
                {
                    value: 'RepackPenerimaan',
                    name: 'Repack',
                },
                {
                    value: 'Tebasan',
                    name: 'Pembayaran DP Tebasan',
                },
                {
                    value: 'PembayaranSupplier',
                    name: 'Pembayaran Supplier',
                },
                {
                    value: 'PinjamanSupplier',
                    name: 'Pinjaman Supplier',
                },
                {
                    value: 'PinjamanSupplierPembayaran',
                    name: 'Pembayaran Pinjaman Supplier',
                },
                {
                    value: 'KomisiGrader',
                    name: 'Komisi Grader',
                },
                {
                    value: 'PenjualanTembakau',
                    name: 'Pembayaran DP Penjualan Tembakau',
                },
                {
                    value: 'PenjualanTembakauPelunasan',
                    name: 'Pelunasan DP Penjualan Tembakau',
                },
                {
                    value: 'RekeningGudang',
                    name: 'Pengisian Kas Kecil',
                },
                {
                    value: 'KasKecil',
                    name: 'Kas Kecil',
                },
            ],
        }
    },

    methods: {
        doSearch() {
            let self = this,
                data = {
                    searchText: self.searchText,
                    searchDate: self.searchDate[0] && self.searchDate[1] ? self.searchDateFormat : null,
                    searchGudangId: self.searchGudang ? self.searchGudang.id : '',
                    searchStatus: self.searchStatus ? self.searchStatus.value : '',
                    searchJenis: self.searchJenis ? self.searchJenis.value : '',
                };
            self.$emit('search-set', data);
        },

        resetSearch() {
            this.searchText = '';
            this.searchDate = '';
            this.searchStatus = '';
            this.searchJenis = '';
            this.searchGudang = null;
            this.$emit('search-reset');
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.searchGudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },
    }
}
</script>
<style>
.search-bar {
    padding: 10px;
}
</style>
